import React, { Component } from "react";
import './chapter-details.scss'
import { getImageSource } from '../../../utility/image-source'
import { Constants, ImageConstants } from '../../../constants/constants'
import Path from '../../routes/routes-path'
import MasterDataApi from '../../../apis/master-data'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleDown, faAngleUp } from '@fortawesome/free-solid-svg-icons'
import { element } from "prop-types";
import HomeworkApi from '../../../apis/homework'
import { Modal, ModalBody, Tooltip, ModalFooter, Button } from "reactstrap";
import SolvedExamples from "../solved-examples/solved-examples";
import CwContentViewer from "../../common/cw-content-viewer/cw-content-viewer";
import ChapterAllVideos from "../view-all-video/view-chapter-all-video";
import PaginationComponent from '../../common/cw-pagination/cw-pagination-v2'
import CommonApi from "../../../apis/common";
import ReactTooltip from "react-tooltip";
import CaseStudyDetail from "../case-study-detail/case-study-detail";
import ChapterActivityDetail from "../chapter-activity-detail/chapter-activity-detail";
import CouponPI from "../../../apis/rewards";
import SessionCache from "../../routes/session-cache";
import RewardApi from '../../../apis/rewards';
import SchoolApi from "../../../apis/school";
import Dropdown from '../../common/dropdown-v2/dropdown';
import VideoSchoolAssignmentApi from "../../../apis/video-school-assignment";
import ToasterComponent from "../../common/cw-toaster-component/cw-toaster-component";
import NotificationModel from '../notification/notification';

const classesExcludeList = ['Class 3', 'Class 4', 'Class 5', 'Class 10', 'Class 11', 'Class 12']

class ChapterDetails extends Component {
    state = {
        title: "Knowing Our Numbers",
        reloadDropdown: false,
        selectedSection: '',
        conceptsName: ["Large Numbers in Practice", "Estimation", "Numbers upto 1 lakh"],
        sectionDropdownItems: [],
        // conceptsInfo: [
        //     {
        //         title: "Large Numbers in Practice",
        //         elos: [
        //             [{ title: "Solve the word problems using operations on large numbers", skill: "KNOWLEDGE" }, { title: "Multiply two large numbers", skill: "KNOWLEDGE" }],
        //             [{ title: "Use of large numbers in metric system", skill: "CALCULATION" }],
        //             [{ title: "Find the difference of two large numbers", skill: "COMPREHENSION" }]
        //         ]
        //     },
        //     {
        //         title: "Estimation",
        //         elos: [
        //             [{ title: "Find a strategy to solve real life problems by estimating results", skill: "KNOWLEDGE" }, { title: "Estimate the difference of two or more numbers", skill: "KNOWLEDGE" }, { title: "Estimate the sum of two numbers", skill: "KNOWLEDGE" }],
        //             [{ title: "Understand the need for estimation and rounding off", skill: "CALCULATION" }],
        //             [{ title: "Round off numbers to nearest thousands", skill: "COMPREHENSION" }]
        //         ]
        //     },
        //     {
        //         title: "Numbers upto 1 lakh",
        //         elos: [
        //             [{ title: "Solve the word problems using operations on large numbers", skill: "KNOWLEDGE" }, { title: "Multiply two large numbers", skill: "KNOWLEDGE" }],
        //             [{ title: "Use of large numbers in metric system", skill: "CALCULATION" }],
        //             [{ title: "Find the difference of two large numbers", skill: "MODELING" }]
        //         ]
        //     },
        // ],

        caseStudyInfo: [
            // {
            //     title : "Case study Title",
            //     questions : [
            //         {
            //             questionTitle : "Question Title"
            //         }
            //     ]
            // },
            // {
            //     title : "Case study Title 2",
            //     questions : [
            //         {
            //             questionTitle : "Question Title 2"
            //         }
            //     ]
            // }
        ],

        chapterActivityInfo: [],



        conceptsInfo: [],

        chapterTitle: this.props.chapterTitle,
        chapterKey: this.props.chapterKey,
        selectedClass: this.props.selectedClass,
        selectedBoard: this.props.selectedBoard,
        showEloList: [],
        showVideoList: [],
        caseStudyAndChapterActivityQuestions: {},
        caseStudyList: [],
        activityList: [],
        xCoord: 0,
        yCoord: 0,
        selectedElement: '',
        rewardAssigned: {},
        selectedEloVideoDetails: {},


        previousKnowledgeInfo: [

            // {
            //     title: "Numbers upto 1 lakh",
            //     elo: [{ title: "Solve the word problems using operations on large numbers", skill: "MODELING" }],
            //     class: "Class 6"
            // },

            // {
            //     title: "Estimation",
            //     elo: [{ title: "Find a strategy to solve real life problems by estimating results", skill: "CALCULATION" }],
            //     class: "Class 7"
            // },

            // {
            //     title: "Large Numbers in Practice",
            //     elo: [{ title: "Find a strategy to solve real life problems by estimating results", skill: "COMPREHENSION" }],
            //     class: "Class 8"
            // },
            // {
            //     title: "Large Numbers in Practice",
            //     elo: [{ title: "Find a strategy to solve real life problems by estimating results", skill: "COMPREHENSION" }],
            //     class: "Class 81"
            // },
            // {
            //     title: "Large Numbers in Practice",
            //     elo: [{ title: "Find a strategy to solve real life problems by estimating results", skill: "COMPREHENSION" }, { title: "Find a strategy to solve real life problems by estimating results", skill: "COMPREHENSION" }],
            //     class: "Class 8"
            // },
            // {
            //     title: "Brackets",
            //     elo: [{ title: "Find a strategy to solve real life problems by estimating results", skill: "COMPREHENSION" }],
            //     class: "Class 81"
            // },
        ]
    }

    classSectionHash = {}



    watchedVideoRewardAddedList = {}

    currentPage = 1;

    constructor(props) {
        super(props)

    }




    componentDidMount() {
        console.log(this.props)
        this.getChapterHierarchy()
        this.getPracticeQuestionsList()
        this.getRewardHistories()
        this.getSections()
        this.getClasses()
    }


    getChapterHierarchy(payload = {}) {

        // if (!this.state.payload || !this.state.payload.chapter) {
        //     return
        // }

        // if (this.state.payload.chapter) {
        //     this.getEloDetails()
        // }


        payload = {
            class: this.props.selectedClass,
            board: this.props.selectedBoard,
            selectedChapter: this.props.chapterKey,
            masterDataId: this.props.masterDataId
            // status: "ONBOARDED"
        }

        console.log(payload)


        HomeworkApi.getChapterHierarchy(payload)
            .then(response => {

                console.log("response", response)

                let conceptsName = [], conceptsDropdownItems = []

                //this.storeConceptDetails(response.chapter)

                for (let i = 0; i < response.chapter.length; i++) {
                    conceptsName.push(response.chapter[i].title)

                    conceptsDropdownItems.push({
                        title: response.chapter[i].title,
                        value: response.chapter[i].conceptKey
                    })
                }


                //console.log(response.previousKnowledgeInfo, this.props.selectedClass)

                let classValue = this.props.selectedClass.split(' ')
                let pkClassValue = classValue[1] - 1

                // As per Ravi we have to Pick only one step back from the Current Class

                let pkInfo = response.previousKnowledgeInfo.filter(pk => pk.class === `${`Class ` + pkClassValue}`)

                console.log(pkInfo)

                let pkEloCount = 0

                pkInfo.forEach(pk => pkEloCount += pk.elo.length)


                this.setState({
                    conceptsInfo: response.chapter,
                    selectedChapterTitle: response.chapter[0].chapterTitle,
                    selectedChapterKey: response.chapter[0].chapterKey,
                    conceptName: conceptsName,
                    chapterIntrodutionVideoLearningContent: response.chapterIntrodutionVideoLearningContent,
                    conceptsDropdownItems: conceptsDropdownItems,
                    previousKnowledgeInfo: pkInfo,
                    chapterSummaryWebLink: response.chapterSummaryWebLink,
                    cheatSheetPdf: response.cheatSheetPdf,
                    pkHomeworkAssigned: response.pkHomeworkAssigned,
                    pkClassworkAssigned: response.pkClassworkAssigned,
                    pkEloCount
                })


            }).catch(err => {
            })
    }

    getPracticeQuestionsList() {

        let payload = {
            chapterKey: this.props.chapterKey,
            masterDataId: this.props.masterDataId,
            isDeleted: 'FALSE',
            page: 1,
            type: ['CASE STUDY', 'CHAPTER ACTIVITY']
        }

        CommonApi.getPracticeQuestion(payload).then(res => {
            console.log(res)

            let caseStudyAndChapterActivityQuestions = {}

            let data = res.response

            let caseStudyInfo = [], chapterActivityInfo = []

            for (let i = 0; i < data.length; i++) {

                let questionData = data[i]


                if (questionData.type === 'CASE STUDY') {
                    let caseStudy = {
                        caseStudyTitle: questionData.question.caseStudyTitle,
                        questions: [questionData.question],
                        _id: questionData._id,
                        webLink: questionData.webLink ? questionData.webLink : ''
                    }
                    caseStudyInfo.push(caseStudy)
                    // if (!caseStudyAndChapterActivityQuestions[`CASE_STUDY`]) {
                    //     caseStudyAndChapterActivityQuestions[`CASE_STUDY`] = [questionData.question]
                    // } else {
                    //     caseStudyAndChapterActivityQuestions[`CASE_STUDY`].push(questionData.question)
                    // }
                } else if (questionData.type === 'CHAPTER ACTIVITY') {

                    let activity = {
                        activityTitle: questionData.question.activityTitle,
                        questions: [questionData.question],
                        _id: questionData._id
                    }

                    chapterActivityInfo.push(activity)

                    // if (!caseStudyAndChapterActivityQuestions[`CHAPTER_ACTIVITY`]) {
                    //     caseStudyAndChapterActivityQuestions[`CHAPTER_ACTIVITY`] = [questionData.question]
                    // } else {
                    //     caseStudyAndChapterActivityQuestions[`CHAPTER_ACTIVITY`].push(questionData.question)
                    // }
                }

            }

            console.log(caseStudyInfo)

            this.setState({ caseStudyAndChapterActivityQuestions, caseStudyInfo, chapterActivityInfo })



        }).catch(err => {
            console.log(err)
        })
    }

    getRewardHistories(payload = {}) {

        if (!payload.page) payload.page = 1

        //payload.limit = this.limit


        // this.currentPage = payload.page

        // this.setState({ isLoading: true })
        RewardApi.getRewardPointsActivity(payload)
            .then(response => {
                let records = response.response
                console.log(records)

                for (let i = 0; i < records.length; i++) {
                    let record = records[i]
                    if (record.type === 'CHAPTER_ACTIVITY_ASSIGN' ||
                        record.type === "WATCHED_VIDEO_ASSIGN" ||
                        record.type === "CASE_STUDY_ASSIGN") {
                        this.watchedVideoRewardAddedList[record.activityId] = true
                    }
                }

                this.setState({ rewardAssigned: this.watchedVideoRewardAddedList })

            }).catch(err => {
                this.setState({ isLoading: false })
            })
    }

    getSections() {

        let payload = {
            board: this.props.selectedBoard,
            class: this.props.selectedClass
        }

        if (!payload.class || !payload.board) {
            this.setState({ sectionDropdownItems: [], selectedSection: "" })
            this.reloadDropdown()
            return
        }

        SchoolApi.getSections(payload)
            .then(response => {
                console.log(response)
                let sections = []
                for (let i = 0; i < response.response.length; i++) {

                    if (!response.response[i].noSectionInClass) {
                        sections.push({
                            title: response.response[i].section,
                            value: response.response[i]._id,
                        })
                    }
                }
                this.classSectionHash[payload.class] = sections
                this.setState({ sectionDropdownItems: sections, selectedSection: "", unAssignedUsersCount: response.unAssignedUsers, noSectionInClassUsersCount: response.noSectionInClassUsersCount })
                this.reloadDropdown()
            }).catch(err => {
                this.setState({ sectionDropdownItems: [], selectedSection: "" })
                this.reloadDropdown()
            })
    }

    getClasses(payload = {}) {
        SchoolApi.getClassAndBoard(payload)
            .then(school => {
                let classes = [], boards = []
                for (let i = 0; i < school.classes.length; i++) {
                    classes.push({
                        title: school.classes[i].name,
                        value: school.classes[i].name,
                    })
                }
                for (let i = 0; i < school.boards.length; i++) {
                    boards.push({
                        title: school.boards[i].name,
                        value: school.boards[i].name,
                    })
                }
                const selectedBoard = boards[0].value
                this.setState({ classes, boards }, _ => { })
            }).catch(err => {
            })
    }

    reloadDropdown() {
        this.setState({ reloadDropdown: true }, () => {
            this.setState({ reloadDropdown: false })
        })
    }


    onClickBack() {
        this.props.back && this.props.back()
    }


    showEloList(index) {
        let showEloList = this.state.showEloList
        this.state.conceptsInfo.forEach((concept, idx) => {
            if (idx !== index) {
                showEloList[idx] = false
            }
        })
        showEloList[index] = showEloList[index] ? false : true

        this.setState({ showEloList, selectedIndex: index })
    }

    showCaseStudyDetail(caseStudyItemDetail) {
        // this.videoEnded(this.state.chapterKey, caseStudyItemDetail.caseStudyTitle, caseStudyItemDetail, "CASE_STUDY", "CASE_STUDY_ASSIGN")
        this.setState({ showCaseStudyDetail: true, caseStudyItemDetail: caseStudyItemDetail })

        // let caseStudyList = this.state.caseStudyList
        // this.state.caseStudyInfo.forEach((caseStudy, idx) => {
        //     if (idx !== index) {
        //         caseStudyList[idx] = false
        //     }
        // })

        // caseStudyList[index] = caseStudyList[index] ? false : true

        // this.setState({ caseStudyList, selectedCaseStudyIndex: index })
    }

    hideCaseStudyDetail() {

        // console.log(this.state.caseStudyItemDetail)

        let id = this.state.caseStudyItemDetail._id
        this.setState({ showCaseStudyDetail: false, caseStudyItemDetail: '' }, () => {
            const element = document.getElementById(id);
            // console.log(id, element)
            element.scrollIntoView({ behavior: "instant", block: 'center' })

        })
    }


    showActivityDetail(chapterActivityItemDetail) {

        // this.videoEnded(this.state.chapterKey, chapterActivityItemDetail.activityTitle, chapterActivityItemDetail, "CHAPTER_ACTIVITY", "CHAPTER_ACTIVITY_ASSIGN")

        this.setState({ showChapterActivityDetail: true, chapterActivityItemDetail: chapterActivityItemDetail })

        // let activityList = this.state.activityList
        // this.state.chapterActivityInfo.forEach((activity, idx) => {
        //     if (idx !== index) {
        //         activityList[idx] = false
        //     }
        // })

        // activityList[index] = activityList[index] ? false : true

        // this.setState({ activityList, selectedActivityIndex: index })
    }

    hideChapterActivityDetail() {

        // console.log(this.state.caseStudyItemDetail)

        let id = this.state.chapterActivityItemDetail._id
        this.setState({ showChapterActivityDetail: false, chapterActivityItemDetail: '' }, () => {
            const element = document.getElementById(id);
            // console.log(id, element)
            element.scrollIntoView({ behavior: "instant", block: 'center' })

        })
    }




    showTableRows() {
        let viewMoreText = document.getElementById('view-more')
        let viewTableRows = [...document.getElementsByClassName('hide-table-row')]

        console.log(viewMoreText.innerHTML)
        if (viewMoreText.innerHTML == "View More") {
            console.log('1')
            viewMoreText.innerHTML = "View Less"
            viewTableRows.forEach(element => element.style.display = 'flex')

        } else {
            console.log('2')

            viewMoreText.innerHTML = "View More"
            viewTableRows.forEach(element => element.style.display = 'none')
        }
    }

    showAssignHomework(concept, type, forWhat) {

        let payload = {
            chapterTitle: this.state.chapterTitle,
            chapterKey: this.state.chapterKey,
            selectedClass: this.state.selectedClass,
            selectedBoard: this.state.selectedBoard,
            conceptKey: concept.conceptKey ? concept.conceptKey : this.state.chapterTitle,
            selectedConceptName: concept.title ? concept.title : this.state.chapterTitle,
            masterDataId: this.props.masterDataId,
            from: "LEARNING_RESOURCES",
            type
        }

        if (forWhat) {
            payload.forWhat = forWhat
            if (type === 'homework') {
                this.setState({ homeworkAssignPayload: payload, selectedConceptName: concept.title ? concept.title : 'on Foundational Learning Outcomes' }, () => {
                    return this.props.delegate?.props?.history.push({ pathname: Path.STANDARD_HOMEWORK, state: { homeworkAssignPayload: this.state.homeworkAssignPayload, showNewHomework: true } })
                })
            } else if (type === 'classwork') {
                this.setState({ homeworkAssignPayload: payload, selectedConceptName: concept.title ? concept.title : 'on Foundational Learning Outcomes' }, () => {
                    return this.props.delegate?.props?.history.push({ pathname: Path.STANDARD_CLASS_WORKS, state: { homeworkAssignPayload: this.state.homeworkAssignPayload, showNewHomework: true } })
                })
            }
        } else {
            if (type === 'homework') {
                this.setState({ showAssignHomeworkPopup: true, homeworkAssignPayload: payload, selectedConceptName: concept.title ? concept.title : 'on Foundational Learning Outcomes' })
            } else if (type === 'classwork') {
                this.setState({ showAssignClassworkPopup: true, homeworkAssignPayload: payload, selectedConceptName: concept.title ? concept.title : 'on Foundational Learning Outcomes' })
            }
        }
    }



    hideAssignHomework() {
        this.setState({ showAssignHomeworkPopup: false })
    }

    hideAssignVideoModal = () => {
        this.setState({ showAssignVideoModal: false })
    }

    hideAssignClasswork() {
        this.setState({ showAssignClassworkPopup: false })
    }

    showViewHomeworkListModal(concept, type, forWhat) {

        let payload = {
            chapterTitle: this.state.chapterTitle,
            chapterKey: this.state.chapterKey,
            selectedClass: this.state.selectedClass,
            selectedBoard: this.state.selectedBoard,
            conceptKey: concept.conceptKey ? concept.conceptKey : this.state.chapterTitle,
            selectedConceptName: concept.title ? concept.title : this.state.chapterTitle,
            masterDataId: this.props.masterDataId,
            from: "LEARNING_RESOURCES"
        }

        if (forWhat) {
            payload.forWhat = forWhat
            if (type === 'homework') {
                this.setState({ homeworkFilterPayload: payload, selectedConceptName: concept.title ? concept.title : 'on Foundational Learning Outcomes' }, () => {
                    return this.props.delegate?.props?.history.push({ pathname: Path.STANDARD_HOMEWORK, state: { homeworkFilterPayload: this.state.homeworkFilterPayload, showHomeworkList: true } })
                })
            } else if (type === 'classwork') {
                this.setState({ homeworkFilterPayload: payload, selectedConceptName: concept.title ? concept.title : 'on Foundational Learning Outcomes' }, () => {
                    return this.props.delegate?.props?.history.push({ pathname: Path.STANDARD_CLASS_WORKS, state: { homeworkFilterPayload: this.state.homeworkFilterPayload, showHomeworkList: true } })
                })
            }

        } else {
            if (type === 'homework') {
                this.setState({ showHomeworkListModal: true, homeworkFilterPayload: payload, selectedConceptName: concept.title })
            } else if (type === 'classwork') {
                this.setState({ showClassworkListModal: true, homeworkFilterPayload: payload, selectedConceptName: concept.title })
            }

        }




    }


    hideViewHomework() {
        this.setState({ showHomeworkListModal: false })
    }

    hideViewClasswork() {
        this.setState({ showClassworkListModal: false })
    }


    showSolvedExample(concept, eloDetail, eloIndex, levelIndex) {

        console.log(eloDetail)

        let selectedElo = {
            chapterTitle: this.state.chapterTitle,
            chapterKey: this.state.chapterKey,
            selectedClass: this.state.selectedClass,
            selectedBoard: this.state.selectedBoard,
            conceptKey: concept.conceptKey,
            selectedConceptName: concept.title,
            ...eloDetail
        }
        this.setState({
            showSolvedExample: true,
            selectedElo: selectedElo,
            selectedEloIndex: eloIndex,
            selectedLevelIndex: levelIndex
        })

    }

    backHandler = () => {

        let id = this.state.selectedElo._id

        this.setState({ showSolvedExample: false }, () => {
            const element = document.getElementById(id);
            console.log(id, element)
            element.scrollIntoView({ behavior: "instant", block: 'center' })

        })
    }

    backHandlerForChapterVideos = () => {

        this.setState({ showChapterAllVideos: false }, () => {

        })
    }



    showLearningOutcomeVideoModal = (concept, eloDetail) => {
        console.log(eloDetail)

        let showVideoList = this.state.showVideoList;

        showVideoList[0] = true


        this.setState({
            showLearningOutcomeVideoModal: true,
            selectedConceptName: concept.title,
            selectedEloVideoDetails: eloDetail,
            videoLearningContentLength: eloDetail.videoLearningContents.length,
            showVideoList,
            selectedVideoIndex: 0,
            showVideoDetail: false,
        })
    }

    showLearningOutcomeVideoAssignModal(concept, eloDetail, introContent, index, contentFrom) {

        console.log(concept, eloDetail, introContent)
        if (eloDetail) {
            let contentIdData = []
            eloDetail.videoLearningContents.forEach(content => {
                contentIdData.push(content._id.toString())
            })
            // console.log(contentIdData.join())
            this.setState({
                showAssignVideoModal: true,
                selectedConcept: concept,
                selectedEloVideoDetails: eloDetail,
                videoLearningContentLength: eloDetail.videoLearningContents.length,
                contentId: contentIdData.join(),
                contentFrom: contentFrom
            })
        } else {
            console.log('else part')
            this.setState({
                showAssignVideoModal: true,
                selectedEloVideoDetails: null,
                contentId: introContent._id,
                contentFrom: contentFrom
            })
        }


    }

    createVideoSchoolAssignment() {

        let eloDetail = this.state.selectedEloVideoDetails

        let payload = {
            board: this.props.selectedBoard,
            class: this.props.selectedClass,
            section: this.state.sectionName,
            sectionId: this.state.selectedSection,
            chapterKey: eloDetail.chapterKey,
            chapterTitle: eloDetail.chapterTitle,
            conceptKey: eloDetail.conceptKey,
            conceptTitle: eloDetail.conceptTitle,
            eloId: eloDetail.elos[0].id,
            eloTitle: eloDetail.elos[0].title,
            videoContentIds: this.state.contentId,
            type: 'TEACHER_RESOURCE_VIDEO'
        }

        VideoSchoolAssignmentApi.createVideoSchoolAssignment(payload).then(res => {
            // console.log(res)
            this.hideAssignVideoModal()
            this.showToaster('info', "Video Shared Successfully to the Students")

        }).catch(err => {
            console.log(err)
        })


    }

    showToaster(type, message) {
        this.setState({
            showToaster: true,
            toasterMessage: message,
            toasterType: type
        }, () => {
            setTimeout(() => { this.hideToaster() }, 5000);
        });
    }

    hideToaster() {
        this.setState({
            showToaster: false
        });
    }


    onPageSelected = (selectedPage, startIndex) => {

        console.log(selectedPage, startIndex)

        let currentIndex = selectedPage - 1

        let showVideoList = this.state.showVideoList;
        this.state.selectedEloVideoDetails.videoLearningContents.forEach((videoContent, idx) => {
            if (idx !== currentIndex) {
                showVideoList[idx] = false
            }
        })

        showVideoList[currentIndex] = showVideoList[currentIndex] ? false : true

        this.setState({ showVideoList, selectedVideoIndex: currentIndex, showVideoDetail: false })



        // let payload = {
        //     page: selectedPage,
        // }
        // this.startIndex = startIndex
        // this.filter.page = selectedPage
        // this.setState({ selectedPage, selectedItemIndex: null, selectedItemGroupIndex: null })
        // this.getHomeworkList(this.filter)
    }



    hideLearningOutcomeVideoModal() {
        this.setState({ showLearningOutcomeVideoModal: false })
    }

    showChapterAllVideos() {
        this.setState({ showChapterAllVideos: true })
    }

    showLearningResourceList() {
        this.setState({ showLearningResourceList: true })
    }

    hideLearningResourceList() {
        this.setState({ showLearningResourceList: false })
    }

    toggleMenu(key) {

        if (key === 'pkExpand') {
            this.setState({ pkExpand: !this.state.pkExpand })
        } else if (key === 'intro_video_expand') {
            this.setState({ showIntroVideoDetail: !this.state.showIntroVideoDetail })
        } else if (key === 'concept_list_expand') {
            this.setState({ showConceptList: !this.state.showConceptList })
        } else if (key === 'case_study_expand') {
            this.setState({ showCaseStudyList: !this.state.showCaseStudyList })
        } else if (key === 'chapter_activity_expand') {
            this.setState({ showChapterActivityList: !this.state.showChapterActivityList })
        }
    }


    showVideoDetail() {
        this.setState({ showVideoDetail: !this.state.showVideoDetail })
    }

    // download = (url, name) => {
    //     console.log('inside')
    //     if (!url) {
    //       throw new Error("Resource URL not provided! You need to provide one");
    //     }
    //     //setFetching(true);
    //     fetch(url)
    //       .then(response => response.blob())
    //       .then(blob => {
    //         //setFetching(false);
    //         const blobURL = URL.createObjectURL(blob);
    //         const a = document.createElement("a");
    //         a.href = blobURL;
    //         a.style = "display: none";

    //         if (name && name.length) a.download = name;
    //         document.body.appendChild(a);
    //         a.click();
    //       })
    //       .catch((err) => 
    //     //   setError(true)
    //       console.log(err)
    //       );
    //   };


    // downloadURI = (uri, name) => {
    //     let link = document.createElement("a");
    //     link.download = name;
    //     link.href = uri;
    //     document.body.appendChild(link);
    //     link.click();
    //     document.body.removeChild(link);
    //     // delete link;
    // }

    downloadFile = (
        filePath,
        fileName = 'Example-PDF-file.pdf',
    ) => {
        fetch(filePath, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/pdf',
            },
            //   mode: 'no-cors'
        })
            .then(response => response.blob())
            .then(blob => {
                const url = window.URL.createObjectURL(new Blob([blob]));
                console.log(url)

                const link = document.createElement('a');
                link.href = url;
                link.download = fileName;

                document.body.appendChild(link);

                link.click();

                link.parentNode.removeChild(link);
            }).catch(err => {
                console.log(err)
            })
    };

    onSelectDropDown = (option, key) => {
        console.log(option, key)
        this.setState({ [key]: option?.value, }, () => {


            if (key == 'selectedSection') {
                // console.log(option.sectionId)
                this.setState({ [key]: option?.sectionId, sectionName: option?.title })
            }
        })
    }


    renderLearningResourceListCard() {
        return (
            <div className="learning-resource-download-list mt-1">
                <img className="close-icon cursor-pointer float-right" onClick={() => this.hideLearningResourceList()} src={getImageSource(ImageConstants.CROSS)} />
                <div className="mt-4 mb-4">
                    <div className="d-flex justify-content-start ml-2" >
                        <div>
                            <a className="anchor-tag" onClick={() => this.downloadFile(this.state.chapterSummaryWebLink)}
                                href={this.state.chapterSummaryWebLink}
                                target="_blank"
                                rel="noreferrer" >
                                <img className="download-icon cursor-pointer mr-2" src={getImageSource(ImageConstants.BLACK_DOWNLOAD_ICON)}></img>
                                <span className="download-item">Chapter Summary</span>
                            </a>
                        </div>
                    </div>
                    <img className="divider-width" src={getImageSource(ImageConstants.LIST_DIVIER)} />

                    <div className="d-flex justify-content-start ml-2">
                        <div>
                            <a className="anchor-tag" href={this.state.cheatSheetPdf} download target='_blank' >
                                <img className="download-icon cursor-pointer mr-2" src={getImageSource(ImageConstants.BLACK_DOWNLOAD_ICON)}></img>
                                <span className="download-item">Cheat Sheet</span>
                            </a>
                        </div>
                    </div>

                </div>
            </div>
        )
    }



    assignHomeworkModal = () => {
        return (
            <Modal className="cw-custom-modal" isOpen={true} toggle={this.hideReminderModal} size={'md'}>
                <ModalBody >
                    <div className="homework-assign-popup">
                        <div className="d-flex justify-content-between heading">
                            <div className="">Assign Homework<div className="heading-subtext">{this.state.selectedConceptName}</div></div>
                            <div className="my-auto"><img className='close-icon close-icon-position cursor-pointer' src={getImageSource(ImageConstants.WHITE_CLOSE_ICON)} onClick={() => this.hideAssignHomework()} /></div>
                        </div>
                        <div className="d-flex justify-content-between heading no-bg-color border-bottom"
                            onClick={() => this.props.delegate?.props?.history.push({ pathname: Path.STANDARD_HOMEWORK, state: { homeworkAssignPayload: this.state.homeworkAssignPayload, showNewHomework: true } })}
                        >
                            <div className="cursor-pointer">Assign Standard Homework</div>
                            <div><img className='arrow-gray cursor-pointer' src={getImageSource(ImageConstants.RIGHT_ARROW)} /></div>
                        </div>
                        <div className="d-flex justify-content-between heading no-bg-color"
                            onClick={() => this.props.delegate?.props?.history.push({ pathname: Path.PERSONALISED_HOMEWORK, state: { homeworkAssignPayload: this.state.homeworkAssignPayload, showNewHomework: true } })}
                        >
                            <div className="cursor-pointer">Assign Personalised Homework</div>
                            <div><img className='arrow-gray cursor-pointer' src={getImageSource(ImageConstants.RIGHT_ARROW)} /></div>
                        </div>
                    </div>
                </ModalBody>
            </Modal>
        )
    }

    // assignVideoModal = () => {
    //     return (
    //         <Modal className="cw-custom-modal" isOpen={true} toggle={this.hideReminderModal} size={'md'}>
    //             <ModalBody >
    //                 <div className="homework-assign-popup">
    //                     <div className="d-flex justify-content-between heading">
    //                         <div className="">Assign Video<div className="heading-subtext">{this.state.selectedConceptName}</div></div>
    //                         <div className="my-auto"><img className='close-icon close-icon-position cursor-pointer' src={getImageSource(ImageConstants.WHITE_CLOSE_ICON)} onClick={() => this.hideAssignVideoModal()} /></div>
    //                     </div>
    //                     <div className="pb-3" style={{ backgroundColor: "#F5F6FA" }}>
    //                         <div className="row heading-for-section">
    //                             <div className="col-lg-6 col-md-6 col-sm-12">
    //                                 <div className="filter-input-label">
    //                                     Section
    //                                 </div>
    //                                 <div >
    //                                     {
    //                                         !this.state.reloadDropdown ?
    //                                             <Dropdown
    //                                                 key="class"
    //                                                 placeholder='Select a Section'
    //                                                 options={this.state.sectionDropdownItems}
    //                                                 onSelect={(option) => this.onSelectDropDown(option, "selectedSection")}
    //                                                 text={"title"}
    //                                                 value={this.state.selectedSection}

    //                                             >
    //                                             </Dropdown>
    //                                             : ""
    //                                     }
    //                                 </div>
    //                             </div>
    //                         </div>
    //                         <div className="d-flex justify-content-center mt-3" >
    //                             <div className="text-center assign-video-button cursor-pointer" onClick={() => this.createVideoSchoolAssignment()}  >Assign</div>
    //                         </div>
    //                     </div>


    //                 </div>
    //             </ModalBody>
    //         </Modal>
    //     )
    // }

    assignVideoModal = () => {
        return (
            <Modal className="cw-custom-modal-for-video-assignment" isOpen={true} toggle={this.hideAssignVideoModal} size={'lg'}>
                <ModalBody >

                    <div className="row">
                        <div className="col text-right">
                            <img alt="" className="close-icon cursor-pointer" onClick={this.hideAssignVideoModal} src={getImageSource(ImageConstants.CROSS)} />
                        </div>
                    </div>

                    <div className="header-text text-center">
                        <span>Share the Video on Whatsapp</span>
                    </div>
                    <NotificationModel type={"WHATSAPP"}
                        onOk={this.onSentNotification}
                        classes={this.state.classes}
                        boards={this.state.boards}
                        selectedEloVideoDetails={this.state.selectedEloVideoDetails}
                        contentId={this.state.contentId}
                        chapterTitle={this.state.selectedChapterTitle}
                        chapterKey={this.props.chapterKey}
                        conceptTitle={this.state.selectedConcept ? this.state.selectedConcept.title : 'Chapter Introduction'}
                        contentFrom={this.state.contentFrom ? this.state.contentFrom : ''}
                        hideAssignVideoModal={() => this.hideAssignVideoModal()}
                        showToaster={(type, msg) => this.showToaster(type, msg)} />
                </ModalBody>
            </Modal>
        )
    }


    assignClassworkModal = () => {
        return (
            <Modal className="cw-custom-modal" isOpen={true} toggle={this.hideReminderModal} size={'md'}>
                <ModalBody >
                    <div className="homework-assign-popup">
                        <div className="d-flex justify-content-between heading">
                            <div className="">Assign Schoolwork<div className="heading-subtext">{this.state.selectedConceptName}</div></div>
                            <div className="my-auto"><img className='close-icon close-icon-position cursor-pointer' src={getImageSource(ImageConstants.WHITE_CLOSE_ICON)} onClick={() => this.hideAssignClasswork()} /></div>
                        </div>
                        <div className="d-flex justify-content-between heading no-bg-color border-bottom"
                            onClick={() => this.props.delegate?.props?.history.push({ pathname: Path.STANDARD_CLASS_WORKS, state: { homeworkAssignPayload: this.state.homeworkAssignPayload, showNewHomework: true } })}
                        >
                            <div className="cursor-pointer">Assign Standard Schoolwork</div>
                            <div><img className='arrow-gray cursor-pointer' src={getImageSource(ImageConstants.RIGHT_ARROW)} /></div>
                        </div>
                        <div className="d-flex justify-content-between heading no-bg-color"
                            onClick={() => this.props.delegate?.props?.history.push({ pathname: Path.PERSONALISED_CLASS_WORK, state: { homeworkAssignPayload: this.state.homeworkAssignPayload, showNewHomework: true } })}
                        >
                            <div className="cursor-pointer">Assign Personalised Schoolwork</div>
                            <div><img className='arrow-gray cursor-pointer' src={getImageSource(ImageConstants.RIGHT_ARROW)} /></div>
                        </div>
                        {/* <div className="d-flex justify-content-between heading no-bg-color border-bottom"
                            onClick={() => this.props.delegate?.props?.history.push({ pathname: Path.STANDARD_CLASS_WORKS, state: { homeworkAssignPayload: this.state.homeworkAssignPayload, type: "CLICKER_PRACTICE_STANDARD" } })}
                        >
                            <div className="cursor-pointer">Assign Schoolwork Using Clicker</div>
                            <div><img className='arrow-gray cursor-pointer' src={getImageSource(ImageConstants.RIGHT_ARROW)} /></div>
                        </div> */}
                    </div>
                </ModalBody>
            </Modal>
        )
    }


    viewHomeworkListModal = () => {
        return (
            <Modal className="cw-custom-modal" isOpen={true} toggle={this.hideReminderModal} size={'md'}>
                <ModalBody >
                    <div className="homework-assign-popup">
                        <div className="d-flex justify-content-between heading">
                            <div className="">View Homework List<div className="heading-subtext">{this.state.selectedConceptName}</div></div>
                            <div className="my-auto"><img className='close-icon close-icon-position cursor-pointer' src={getImageSource(ImageConstants.WHITE_CLOSE_ICON)} onClick={() => this.hideViewHomework()} /></div>
                        </div>
                        <div className="d-flex justify-content-between heading no-bg-color border-bottom"
                            onClick={() => this.props.delegate?.props?.history.push({ pathname: Path.STANDARD_HOMEWORK, state: { homeworkFilterPayload: this.state.homeworkFilterPayload, showHomeworkList: true } })}
                        >
                            <div className="cursor-pointer">View Standard Homework List</div>
                            <div><img className='arrow-gray cursor-pointer' src={getImageSource(ImageConstants.RIGHT_ARROW)} /></div>
                        </div>
                        <div className="d-flex justify-content-between heading no-bg-color"
                            onClick={() => this.props.delegate?.props?.history.push({ pathname: Path.PERSONALISED_HOMEWORK, state: { homeworkFilterPayload: this.state.homeworkFilterPayload, showHomeworkList: true } })}
                        >
                            <div className="cursor-pointer">View Personalised Homework List</div>
                            <div><img className='arrow-gray cursor-pointer' src={getImageSource(ImageConstants.RIGHT_ARROW)} /></div>
                        </div>
                    </div>
                </ModalBody>
            </Modal>
        )
    }

    viewClassworkListModal = () => {
        return (
            <Modal className="cw-custom-modal" isOpen={true} toggle={this.hideReminderModal} size={'md'}>
                <ModalBody >
                    <div className="homework-assign-popup">
                        <div className="d-flex justify-content-between heading">
                            <div className="">View Schoolwork List<div className="heading-subtext">{this.state.selectedConceptName}</div></div>
                            <div className="my-auto"><img className='close-icon close-icon-position cursor-pointer' src={getImageSource(ImageConstants.WHITE_CLOSE_ICON)} onClick={() => this.hideViewClasswork()} /></div>
                        </div>
                        <div className="d-flex justify-content-between heading no-bg-color border-bottom"
                            onClick={() => this.props.delegate?.props?.history.push({ pathname: Path.STANDARD_CLASS_WORKS, state: { homeworkFilterPayload: this.state.homeworkFilterPayload, showHomeworkList: true } })}
                        >
                            <div className="cursor-pointer">View Standard Schoolwork List</div>
                            <div><img className='arrow-gray cursor-pointer' src={getImageSource(ImageConstants.RIGHT_ARROW)} /></div>
                        </div>
                        <div className="d-flex justify-content-between heading no-bg-color"
                            onClick={() => this.props.delegate?.props?.history.push({ pathname: Path.PERSONALISED_CLASS_WORK, state: { homeworkFilterPayload: this.state.homeworkFilterPayload, showHomeworkList: true } })}
                        >
                            <div className="cursor-pointer">View Personalised Schoolwork List</div>
                            <div><img className='arrow-gray cursor-pointer' src={getImageSource(ImageConstants.RIGHT_ARROW)} /></div>
                        </div>
                    </div>
                </ModalBody>
            </Modal>
        )
    }


    watchLearningOutcomeVideo = () => {
        return (
            <Modal className="cw-custom-modal-for-video" isOpen={true} toggle={this.hideReminderModal} size={'xl'}>
                <ModalBody >
                    <div className="position-relative">
                        <img className="video-detail-polygon" src={getImageSource(ImageConstants.VIDEO_DETAIL_POLYGON)} />
                        <div className="d-flex justify-content-between align-items-center heading ">
                            <div className="d-flex align-items-center">
                                <div className="mr-2">
                                    <img className="book-with-apple" src={getImageSource(ImageConstants.PLAY_ICON_ORANGE)} />
                                </div>
                                <div className="">{this.state.selectedEloVideoDetails.title}<div className="heading-subtext">{this.state.selectedConceptName}</div></div>
                            </div>

                            <div className=""><img className='close-icon close-icon-position cursor-pointer' src={getImageSource(ImageConstants.CROSS)} onClick={() => this.hideLearningOutcomeVideoModal()} /></div>
                        </div>

                        <div className="mb-2">
                            {this.state.selectedEloVideoDetails?.videoLearningContents?.map((videoContent, index) => (
                                <>
                                    {this.state.showVideoList[index] && this.state.selectedVideoIndex === index &&
                                        <>
                                            <div className="row">
                                                <div className="col mb-2"><CwContentViewer from={'video_only'} content={videoContent.content.description}
                                                    videoEnded={() => this.videoEnded(this.state.selectedChapterKey, this.state.selectedEloVideoDetails.title, videoContent, "ELO_VIDEO_WATCHED", "WATCHED_VIDEO_ASSIGN")}
                                                /></div>
                                            </div>
                                            <div className="d-flex justify-content-center">
                                                <div className="read-more-wrapper">
                                                    <span className="read-more cursor-pointer" onClick={() => this.showVideoDetail()}>{`${this.state.showVideoList[index] && this.state.selectedVideoIndex === index && this.state.showVideoDetail == true ? 'Hide More' : 'Read More'}`}</span>
                                                </div>
                                            </div>
                                            {
                                                this.state.showVideoList[index] && this.state.selectedVideoIndex === index && this.state.showVideoDetail == true ?
                                                    <div className="p-4 position-relative">
                                                        <img className="video-detail-header-image" src={getImageSource(ImageConstants.VIDEO_DETAIL_HEADER_IMAGE)} />
                                                        <div className="video-detail-wrapper">
                                                            <div className="elo-title p-4">
                                                                {this.state.selectedEloVideoDetails.title}
                                                            </div>
                                                            <div className="video-detail-divider"></div>
                                                            <div className="pl-4 pr-4">
                                                                <div className="d-flex video-learning-content-wrapper mt-4 mb-4 pb-2">
                                                                    <div className='video-learning-content row '>
                                                                        <div className="col content-alignment mt-2">
                                                                            <div className='d-flex video-learning-content-title'>
                                                                                <div className='mr-1 sr-no '><span className='mt-3 sr-no-bg-color'>{`${index + 1}.`}</span></div>
                                                                                <div className='align-self-center sr-no'>{videoContent.title} </div>
                                                                            </div>
                                                                            <div className="video-content-wrapper">
                                                                                {<CwContentViewer from={'video_content'} content={videoContent.content.description} />}
                                                                            </div>

                                                                        </div>

                                                                    </div>
                                                                </div>
                                                            </div>


                                                        </div>
                                                    </div>

                                                    : <></>
                                            }


                                        </>

                                    }
                                </>

                            ))}
                        </div>

                        <div className='card-footer'>
                            {
                                this.state.videoLearningContentLength ?
                                    <PaginationComponent startIndex={this.startIndex} selectedPage={this.currentPage} totalPages={this.state.videoLearningContentLength} onPageSelected={this.onPageSelected.bind(this)} /> : ''
                            }
                        </div>

                    </div>
                </ModalBody>
            </Modal>
        )
    }


    getVideoContent(videoContent) {

        // let parsedContent = <CwContentViewer content = {videoContent} />

        // console.log(parsedContent)
    }

    videoEnded(chapterKey, chapterTitle, content, subType, type) {

        console.log(content)

        if (this.watchedVideoRewardAddedList[`${chapterKey}_${content._id}`]) {
            // console.log('returned')
            return;
        }

        let payload = {
            type: type,
            subType: subType,
            chapterKey,
            chapterTitle: this.state.chapterTitle,
            contentTitle: chapterTitle,
            contentId: content._id,
            board: this.state.selectedBoard,
            class: this.state.selectedClass
        }

        CouponPI.addVideoWatchedRewardPoint(payload).then((res) => {
            if (res.data.rewardPointAdded && res.data.chapterKey) {
                this.watchedVideoRewardAddedList[`${res.data.chapterKey}`] = true
            }

            if (type === "CASE_STUDY_ASSIGN" || type === "CHAPTER_ACTIVITY_ASSIGN") {
                this.setState({ rewardAssigned: this.watchedVideoRewardAddedList })
            }

            this.setState({})
        }).catch(err => {
            console.log(err)
        })


    }

    videoPlayed(chapterKey, chapterTitle) {
        console.log(chapterKey, chapterTitle)
    }




    render() {


        if (this.state.showSolvedExample) {
            return (
                <SolvedExamples selectedElo={this.state.selectedElo}
                    back={this.backHandler}
                    goToChapterListScreen={() => this.props.back && this.props.back()} />
            )
        }

        if (this.state.showChapterAllVideos) {
            return (
                <ChapterAllVideos
                    selectedClass={this.props.selectedClass}
                    selectedBoard={this.props.selectedBoard}
                    masterDataId={this.props.masterDataId}
                    chapterKey={this.props.chapterKey}
                    chapterTitle={this.state.selectedChapterTitle}
                    back={this.backHandlerForChapterVideos}
                    conceptsInfo={this.state.conceptsInfo}
                    chapterIntroductionVideo={this.state.chapterIntrodutionVideoLearningContent}
                    conceptsDropdownItems={this.state.conceptsDropdownItems}
                    goToChapterListScreen={() => this.props.back && this.props.back()}
                    videoEnded={(chapterKey, chapterTitle, content, subType, type) => this.videoEnded(chapterKey, chapterTitle, content, subType, type)} />
            )
        }

        if (this.state.showCaseStudyDetail) {
            return (
                <CaseStudyDetail
                    caseStudyInfo={this.state.caseStudyItemDetail}
                    back={() => this.hideCaseStudyDetail()}
                    selectedClass={this.props.selectedClass}
                    chapterTitle={this.state.selectedChapterTitle}
                    goToChapterListScreen={() => this.props.back && this.props.back()}
                />
            )
        }

        if (this.state.showChapterActivityDetail) {
            return (
                <ChapterActivityDetail
                    chapterActivityInfo={this.state.chapterActivityItemDetail}
                    back={() => this.hideChapterActivityDetail()}
                    selectedClass={this.props.selectedClass}
                    chapterTitle={this.state.selectedChapterTitle}
                    goToChapterListScreen={() => this.props.back && this.props.back()}
                />
            )
        }


        return (
            <div className="chapter-details mb-5" onScroll={ReactTooltip.hide()}>
                {/* <div className='mb-3 cursor-pointer' onClick={_ => this.props.delegate?.props.history.push({ pathname: Path.PERSONALISED_HOMEWORK, showList: true })}>
                    <img className='ad-banner' src={getImageSource(ImageConstants.AD_BANNER_1)} />
                </div> */}
                <div>
                    <img alt="" className='back-icon cursor-pointer' src={getImageSource(ImageConstants.BACK_ICON)} onClick={() => this.onClickBack()} />
                </div>
                <div className="chapter-title-card  d-flex justify-content-between mt-3">
                    <div className="d-flex align-items-center">
                        <div className="mr-2 chapter-image-wrapper">
                            <img className="chapter-image-size" src={this.props.chapterImageURL ? this.props.chapterImageURL : getImageSource(ImageConstants.CHAPTER_ICN)} />
                        </div>
                        <div>
                            <div className="chapter-title">{this.state.chapterTitle}</div>
                            <div className="class-name" onClick={() => this.onClickBack()}>{this.state.selectedClass}</div>
                        </div>
                    </div>
                    <div className="align-self-center text-center position-relative mt-2" onMouseEnter={ReactTooltip.rebuild}>
                        {/* <span className="watch-video-text learning-resources-text cursor-pointer p-2 mr-3" onClick={() => this.showLearningResourceList()} > <img className="download-icon mr-1" src={getImageSource(ImageConstants.WHITE_DOWNLOAD_ICON)} /> LEARNING RESOURCES</span>
                        <span className="watch-video-text cursor-pointer p-2 mr-4" onClick={() => this.showChapterAllVideos()} > <img className="video-icon mr-1" src={getImageSource(ImageConstants.WHITE_VIDEO_ICON)} /> VIEW ALL VIDEOS</span> */}
                        <span className="mr-3"  > <img className="video-icon-new mr-1 cursor-pointer" onClick={() => this.showChapterAllVideos()} src={getImageSource(ImageConstants.PLAY_ICON_GREEN_BG)} data-tip={'VIEW ALL VIDEOS'} /></span>
                        <span className="mr-4"  > <img className="download-icon-new mr-1 cursor-pointer" onClick={() => this.showLearningResourceList()} src={getImageSource(ImageConstants.DOWNLOAD_ICON_BLUE_BG)} data-tip={'DOWNLOAD LEARNING RESOURCES'} /></span>
                        {
                            this.state.showLearningResourceList ?
                                this.renderLearningResourceListCard()
                                :
                                <></>
                        }
                    </div>

                </div>



                {this.state.previousKnowledgeInfo.length > 0 && !classesExcludeList.includes(this.state.selectedClass) ?
                    <div className="previous-knowledge-card mt-4">
                        <img className="pk-polygon" src={getImageSource(ImageConstants.PK_POLYGON)} />
                        <div className="d-flex justify-content-between align-items-center cursor-pointer p-3" onClick={() => this.toggleMenu('pkExpand')}>
                            <div className="d-flex align-items-center">
                                <div className="mr-2">
                                    <img className="book-with-apple" src={getImageSource(ImageConstants.BOOK_WITH_APPLE)} />
                                </div>
                                <div className="heading heading-margin">Foundational Learning Outcomes <span className="count-text">{` (${this.state.pkEloCount})`}</span> </div>

                            </div>
                            <div>
                                <img className="arrow-size cursor-pointer" src={getImageSource(this.state.pkExpand == true ? ImageConstants.ARROW_UP_ANGLE : ImageConstants.ARROW_DOWN_ANGLE)} />
                            </div>
                        </div>

                        {
                            this.state.pkExpand == true ?
                                <>
                                    <div className="divider-line"></div>
                                    <div className="row px-4 pt-2 ">
                                        <div className="col"></div>
                                        <div className="col-2 ">
                                            {/* <div className="homework-title">Homework</div>
                                            <div className="d-flex align-items-center mt-1" onMouseEnter={ReactTooltip.rebuild}>
                                               
                                                <div>
                                                    <img className="assign-classwork-icon cursor-pointer" src={getImageSource(ImageConstants.ASSIGN_HOMEWORK)} onClick={() => this.showAssignHomework('', 'homework', "PREVIOUS_KNOWLEDGE")} data-tip={'Assign Homework on Previous Knowledge'} />
                                                </div>
                                                <div>
                                                    <img className="assign-classwork-icon ml-3 cursor-pointer" src={getImageSource(ImageConstants.VIEW_HOMEWORK)} onClick={() => this.showViewHomeworkListModal('', 'homework', 'PREVIOUS_KNOWLEDGE')} data-tip={'View Homework on Previous Knowledge'} />
                                                </div>
                                                <div className="info-box ml-3">
                                                    <div className="text-center">
                                                        <img className="info-icon-blue-size mr-2" src={getImageSource(ImageConstants.INFO_BLUE)} />
                                                        {this.state.pkHomeworkAssigned ? <img className="info-icon-blue-size" src={getImageSource(ImageConstants.GREEN_TICK_MARK)} data-tip={'Assigned'} /> : <img className="info-icon-blue-size" src={getImageSource(ImageConstants.WRONG)} data-tip={'Not Assigned'} />}
                                                    </div>
                                                </div>

                                            </div> */}
                                        </div>
                                        {/* <img className="homework-divider" src={getImageSource(ImageConstants.HOMEWORK_DIVIDER)} /> */}
                                        <div className="col-2 mb-2">
                                            <div className="homework-title">Schoolwork</div>
                                            <div className="d-flex align-items-center mt-1" onMouseEnter={ReactTooltip.rebuild}>
                                                {/* <span className="assign-homework"> */}
                                                <div>
                                                    <img className="assign-classwork-icon cursor-pointer" src={getImageSource(ImageConstants.ASSIGN_CLASSWORK)} onClick={() => this.showAssignHomework("", 'classwork', 'PREVIOUS_KNOWLEDGE')}
                                                        data-tip={'Assign Schoolwork on Previous Knowledge'} />
                                                </div>

                                                {/* </span> */}
                                                {/* <span className="assign-homework ml-2"> */}
                                                <div>
                                                    <img className="assign-classwork-icon ml-3 cursor-pointer" src={getImageSource(ImageConstants.VIEW_CLASSWORK)} onClick={() => this.showViewHomeworkListModal('', 'classwork', 'PREVIOUS_KNOWLEDGE')} data-tip={'View Schoolwork on Previous Knowledge'} />
                                                </div>

                                                {/* </span> */}
                                                <div className="info-box ml-3">
                                                    <div className="text-center">
                                                        <img className="info-icon-blue-size mr-2" src={getImageSource(ImageConstants.INFO_BLUE)} />
                                                        {this.state.pkClassworkAssigned || this.state.pkHomeworkAssigned ? <img className="info-icon-blue-size" src={getImageSource(ImageConstants.GREEN_TICK_MARK)} data-tip={'Assigned'} /> : <img className="info-icon-blue-size" src={getImageSource(ImageConstants.WRONG)} data-tip={'Not Assigned'} />}
                                                    </div>
                                                </div>

                                            </div>
                                        </div>

                                    </div>
                                    <div class="table-responsive px-4 pb-4">
                                        <table className="table table-bordered">
                                            <thead>
                                                <tr className="d-flex th-bg-color">
                                                    <th className="col-4  border-top-left-radius table-head">Concept from Previous Class</th>
                                                    <th className="col-8 table-head border-top-right-radius" >Learning Outcome</th>
                                                    {/* <th className="col-2 table-head border-top-right-radius">Class</th> */}
                                                </tr>
                                            </thead>
                                            <tbody id="table-id">
                                                {this.state.previousKnowledgeInfo.map((pk, index) => (
                                                    <tr key={index} className={`table-row-display ${(index >= 3) ? "hide-table-row" : ''} ${index === 0 ? "row-border-top" : ''} `}>
                                                        <td className="col-4  table-row-text-for-concept text-center"><div className="align-middle">{pk.title}</div></td>
                                                        {pk.elo.length > 0 ?
                                                            <td className="col-8 table-row-text">
                                                                {pk.elo.map((elo, eIndex) => (
                                                                    <div id={elo._id} className="row m-0 mb-3 align-items-center">
                                                                        <div className="col-8 mt-1">
                                                                            <img className="skill-image mr-2" src={getImageSource(ImageConstants[`${elo.skill == "MODELLING" ? "MODELING" : elo.skill}`])} />
                                                                            {elo.title}
                                                                        </div>
                                                                        {elo.videoLearningContents?.length ?
                                                                            <div className="watch-video-text  mr-3" >
                                                                                <div className="d-inline-block video-image-container">
                                                                                    <img className="video-icon-new mr-1 cursor-pointer" src={getImageSource(ImageConstants.VIDEO_PLAY_ICON_NEW)} data-tip={"Watch Video"}
                                                                                        onClick={() => this.showLearningOutcomeVideoModal(pk, elo, eIndex, 1)} />
                                                                                    <span className="span-divider"></span>
                                                                                    <img className="share-icon ml-2 cursor-pointer" onClick={() => this.showLearningOutcomeVideoAssignModal(pk, elo, eIndex, 1, 'CHAPTER_PK')} src={getImageSource(ImageConstants.SHARE_ICON)} data-tip={"Share Video"} />
                                                                                </div>

                                                                            </div> : ''}

                                                                        {elo.solvedExampleLearningContents?.length ?
                                                                            <div className="watch-video-text cursor-pointer " onClick={() => this.showSolvedExample(pk, elo, eIndex, 1)}>
                                                                                <img className="video-icon mr-1" src={getImageSource(ImageConstants.SOLVED_EXAMPLE_ICON)} data-tip={"Solved Example"} />
                                                                                {/* Solved Example */}
                                                                            </div> : ''}
                                                                    </div>


                                                                ))}

                                                            </td>



                                                            : <td className="col-8 table-row-text "><img className="skill-image mr-2" src={getImageSource(ImageConstants[`${pk.elo[0].skill == "MODELLING" ? "MODELING" : pk.elo[0].skill}`])} />{pk.elo[0].title}</td>}


                                                        {/* <td className="col-2 table-row-text text-center ">{pk.class}</td> */}
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>

                                    <div className="d-flex justify-content-end">
                                        {
                                            this.state.previousKnowledgeInfo.map((pk, index) => (
                                                <div className="cursor-pointer" onClick={() => this.showTableRows()}>
                                                    {index === 3 ? <div id='view-more'>{`View More`}</div> : ''}
                                                </div>
                                            ))
                                        }

                                    </div>
                                </> : <></>
                        }


                    </div>
                    : ''}

                {
                    !classesExcludeList.includes(this.state.selectedClass) ?
                        <div className="chapter-introduction-card mt-4">
                            <img className="blue-dimond-icon" src={getImageSource(ImageConstants.BLUE_DIMOND_ICON)} />
                            <div className="d-flex justify-content-between align-items-center cursor-pointer p-3" onClick={() => this.toggleMenu('intro_video_expand')}>
                                <div className="d-flex align-items-center">
                                    <div className="mr-2">
                                        <img className="book-with-apple" src={getImageSource(ImageConstants.VIDEO_PLAY_ICON)} />
                                    </div>
                                    <div className="heading">
                                        Chapter Introduction Video
                                    </div>
                                </div>
                                <div>
                                    <img className="arrow-size" src={getImageSource(this.state.showIntroVideoDetail == true ? ImageConstants.ARROW_UP_ANGLE : ImageConstants.ARROW_DOWN_ANGLE)} />
                                </div>
                            </div>

                            {
                                this.state.showIntroVideoDetail == true ?
                                    <>
                                        <div className='divider mt-1 mb-1'></div>

                                        {this.state.chapterIntrodutionVideoLearningContent?.length &&
                                            this.state.chapterIntrodutionVideoLearningContent.map((introVideoContent, index) => (
                                                <div className='p-4' onMouseEnter={ReactTooltip.rebuild}>
                                                    {/* <div className='d-flex video-learning-content-title mb-1'>
               

            </div> */}
                                                    <div className='video-learning-content row'>
                                                        <div className="col-4" >
                                                            <CwContentViewer from={'video_only'} content={introVideoContent.content.description}
                                                                videoEnded={() => this.videoEnded(this.state.selectedChapterKey, introVideoContent.title, introVideoContent, "CHAPTER_INTRODUCTION_VIDEO_WATCHED", "WATCHED_VIDEO_ASSIGN")} />
                                                            <img className="chapter_intro_share_icon cursor-pointer"
                                                                style={{ display: "block" }}
                                                                src={getImageSource(ImageConstants.SHARE_ICON_BLACK)} data-tip={'Share Video'}
                                                                onClick={() => this.showLearningOutcomeVideoAssignModal(null, null, introVideoContent, null, 'CHAPTER_INTRO')} />
                                                        </div>
                                                        <div className="col-8 mt-2">
                                                            <div className="video-content-title ">{introVideoContent.title} </div>
                                                            {<CwContentViewer from={'video_content'} content={introVideoContent.content.description} />}
                                                        </div>
                                                    </div>
                                                </div>

                                            ))}
                                    </>

                                    : <></>
                            }


                            {/* <div className="row mt-3">
                        <div className="col-4 content-right ml-3 p-2">
                            <div className="video-wrapper ">
                                <video className="video-content" width="350" controls>
                                    <source src={"https://countingwell-public-content-prod.s3.ap-south-1.amazonaws.com/13eb1263-6c57-458c-a84e-7291d654bb92_NEP%20Aligned%20Maths%20Learning%20for%20School.mp4"} type="video/mp4" />
                                </video>
                            </div>
                        </div>
                        <div className="col-7  p-2">
                            <div className="chapter-intro-heading">Why are we learning Circles?</div>
                            <div className="chapter-intro-text mt-2">Lorem ipsum dolor sit amet consectetur. Urna in venenatis adipiscing eu neque viverra sit. Egestas duis interdum a sagittis in suspendisse. Aliquam non tortor gravida lacus. Diam vulputate vitae a elementum. Iaculis a curabitur lacus tristique. At molestie donec suspendisse facilisis pretium vitae nunc id. Odio urna nec id rhoncus velit.</div>
                        </div>
                    </div> */}
                        </div>
                        :
                        <></>

                }



                <div className="concept-card mt-4">
                    <img className="green-eclipse" src={getImageSource(ImageConstants.GREEN_ECLIPSE_ICON)} />
                    <div className="d-flex justify-content-between align-items-center cursor-pointer p-3" onClick={() => this.toggleMenu('concept_list_expand')}>
                        <div className="d-flex align-items-center">
                            <div className="mr-2">
                                <img className="book-with-apple" src={getImageSource(ImageConstants.BLUE_BOOK_ICON)} />
                            </div>
                            <div className="heading">Concepts <span className="count-text">{` (${this.state.conceptsInfo.length})`}</span> </div>
                        </div>
                        <div>
                            <img className="arrow-size" src={getImageSource(this.state.showConceptList == true ? ImageConstants.ARROW_UP_ANGLE : ImageConstants.ARROW_DOWN_ANGLE)} />
                        </div>
                    </div>

                    {
                        this.state.showConceptList === true ?
                            <>
                                <div className='divider mt-1 mb-1'></div>
                                <div className="p-4">
                                    {
                                        this.state.conceptsInfo.length && this.state.conceptsInfo.map((concept, index) => (
                                            <div key={index} onMouseEnter={ReactTooltip.rebuild}
                                                className={`concept-info `
                                                }>
                                                <div className={`concept-list-item mt-2 ${this.state.showEloList[index] && this.state.selectedIndex === index ? 'color-border' : ""}`}>

                                                    {
                                                        this.state.showEloList[index] && this.state.selectedIndex === index ?
                                                            <div className="row align-items-center pl-4 pt-2">
                                                                <div className="col cursor-pointer" onClick={() => this.showEloList(index)}>
                                                                    <span className="concept-title " >{concept.title}</span>
                                                                    <span className="ml-2 elo-count">{`(${concept.conceptWiseEloCount})`}</span>
                                                                </div>
                                                                <div className="col-2 ">
                                                                    {/* <div className="homework-title">Homework</div>
                                                                    <div className="d-flex align-items-center mt-1" onMouseEnter={ReactTooltip.rebuild}>
                                                                        
                                                                        <div>
                                                                            <img className="assign-classwork-icon cursor-pointer" src={getImageSource(ImageConstants.ASSIGN_HOMEWORK)} onClick={() => this.showAssignHomework(concept, 'homework')} data-tip={'Assign Homework'} />
                                                                        </div>

                                                                       
                                                                        <div>
                                                                            <img className="assign-classwork-icon ml-3 cursor-pointer" src={getImageSource(ImageConstants.VIEW_HOMEWORK)} onClick={() => this.showViewHomeworkListModal(concept, 'homework')} data-tip={'View Homework'} />
                                                                        </div>

                                                                        
                                                                        <div className="info-box ml-3">
                                                                            <div className="text-center">
                                                                                <img className="info-icon-blue-size" src={getImageSource(ImageConstants.INFO_BLUE)} />
                                                                                <span className="ml-2 homework-count">{concept.conceptWiseHomeworkAssignedCount}</span>
                                                                            </div>
                                                                        </div>

                                                                    </div> */}
                                                                </div>
                                                                {/* <img className="homework-divider" src={getImageSource(ImageConstants.HOMEWORK_DIVIDER)} /> */}
                                                                <div className="col-2 mb-2">
                                                                    <div className="homework-title">Schoolwork</div>
                                                                    <div className="d-flex align-items-center mt-1" onMouseEnter={ReactTooltip.rebuild}>
                                                                        {/* <span className="assign-homework"> */}
                                                                        <div>
                                                                            <img className="assign-classwork-icon cursor-pointer" src={getImageSource(ImageConstants.ASSIGN_CLASSWORK)} onClick={() => this.showAssignHomework(concept, 'classwork')} data-tip={'Assign Schoolwork'} />
                                                                        </div>

                                                                        {/* </span> */}
                                                                        {/* <span className="assign-homework ml-2"> */}
                                                                        <div>
                                                                            <img className="assign-classwork-icon ml-3 cursor-pointer" src={getImageSource(ImageConstants.VIEW_CLASSWORK)} onClick={() => this.showViewHomeworkListModal(concept, 'classwork')} data-tip={'View Schoolwork'} />
                                                                        </div>

                                                                        {/* </span> */}
                                                                        <div className="info-box ml-3">
                                                                            <div className="text-center">
                                                                                <img className="info-icon-blue-size" src={getImageSource(ImageConstants.INFO_BLUE)} />
                                                                                <span className="ml-2 homework-count">{concept.conceptWiseClassworkAssignedCount + concept.conceptWiseHomeworkAssignedCount}</span>
                                                                            </div>
                                                                        </div>

                                                                    </div>
                                                                </div>
                                                                <div className="col-2 text-center cursor-pointer" onClick={() => this.showEloList(index)}>
                                                                    <img className="arrow-icon cursor-pointer ml-5" src={`${this.state.showEloList[index] ? getImageSource(ImageConstants.ARROW_UP_ANGLE) : getImageSource(ImageConstants.ARROW_DOWN_ANGLE)}`} />
                                                                </div>


                                                            </div>
                                                            :
                                                            <div className="d-flex justify-content-between align-items-center p-4 cursor-pointer" onClick={() => this.showEloList(index)}  >
                                                                <div className="d-flex flex-column p-1">
                                                                    <div>
                                                                        <span className="concept-title cursor-pointer" >{concept.title}</span>
                                                                        <span className="ml-2 elo-count">{`( ${concept.conceptWiseEloCount} )`}</span>
                                                                    </div>
                                                                </div>
                                                                <div className="pr-2" >
                                                                    <img className="arrow-icon cursor-pointer" onClick={() => this.showEloList(index)} src={`${this.state.showEloList[index] ? getImageSource(ImageConstants.ARROW_UP_ANGLE) : getImageSource(ImageConstants.ARROW_DOWN_ANGLE)}`} />
                                                                </div>
                                                            </div>
                                                    }




                                                    {this.state.showEloList[index] && this.state.selectedIndex === index &&
                                                        <div className={` elo-list cw-border-bottom`}>
                                                            {
                                                                concept.elos.map((elo, levelIndex) => (
                                                                    <div onMouseEnter={ReactTooltip.rebuild} >
                                                                        <div className="level-text pt-1">Level {levelIndex + 1} </div>
                                                                        {
                                                                            elo.map((item, eloIndex) => (
                                                                                <div id={item._id} className={`row m-0 p-2 ${this.state.selectedIndex === index && this.state.selectedEloIndex === eloIndex && this.state.selectedLevelIndex === levelIndex ? "selected-elo-bg" : ""}`}>
                                                                                    <div className="col-8 elo-name-text p-1 pl-2"><img className="skill-image mr-2" src={getImageSource(ImageConstants[`${item.skill.toUpperCase() == "MODELLING" ? 'MODELING' : item.skill.toUpperCase()}`])} />{item?.title}</div>

                                                                                    {item.videoLearningContents?.length ?
                                                                                        <div className="d-flex align-items-center">
                                                                                            <div className="watch-video-text  mr-3" >
                                                                                                <div className="d-inline-block video-image-container">
                                                                                                    <img className="video-icon-new mr-2 cursor-pointer" onClick={() => this.showLearningOutcomeVideoModal(concept, item, eloIndex, levelIndex)} src={getImageSource(ImageConstants.VIDEO_PLAY_ICON_NEW)} data-tip={"Watch Video"} />
                                                                                                    <span className="span-divider"></span>
                                                                                                    <img className="share-icon ml-2 cursor-pointer" onClick={() => this.showLearningOutcomeVideoAssignModal(concept, item, eloIndex, levelIndex, "ELO_LIST")} src={getImageSource(ImageConstants.SHARE_ICON)} data-tip={"Share Video"} />
                                                                                                </div>

                                                                                                {/* Watch Video */}
                                                                                            </div>

                                                                                        </div>
                                                                                        : ''}

                                                                                    {item.solvedExampleLearningContents?.length ?
                                                                                        <div className="watch-video-text cursor-pointer " onClick={() => this.showSolvedExample(concept, item, eloIndex, levelIndex)}>
                                                                                            <img className="video-icon mr-1" src={getImageSource(ImageConstants.SOLVED_EXAMPLE_ICON)} data-tip={"Solved Example"} />
                                                                                            {/* Solved Example */}
                                                                                        </div> : ''}
                                                                                </div>
                                                                            ))
                                                                        }
                                                                        {concept.elos.length - 1 === levelIndex ? <></> : <img className="gray-center-divider" src={getImageSource(ImageConstants.GRAY_CENTER_DIVIDER)} />}
                                                                    </div>
                                                                ))

                                                            }
                                                        </div>
                                                    }
                                                </div>
                                            </div>
                                        ))
                                    }
                                </div>
                            </>

                            : <></>
                    }

                </div>



                {
                    this.state.caseStudyInfo.length && !classesExcludeList.includes(this.state.selectedClass) ?
                        <>
                            {

                                <div className="case-study-card mt-4">
                                    <img className="case-study-bg" src={getImageSource(ImageConstants.CASE_STUDY_BG)} />
                                    <div className="d-flex justify-content-between align-items-center cursor-pointer p-3" onClick={() => this.toggleMenu('case_study_expand')}>
                                        <div className="d-flex align-items-center">
                                            <div className="mr-2">
                                                <img className="book-with-apple" src={getImageSource(ImageConstants.CASE_STUDY_ICON)} />
                                            </div>
                                            <div className="heading">Case Studies <span className="count-text">{` (${this.state.caseStudyInfo.length})`}</span> </div>
                                        </div>
                                        <div>
                                            <img className="arrow-size-for-case-study" src={getImageSource(this.state.showCaseStudyList == true ? ImageConstants.ARROW_UP_ANGLE : ImageConstants.ARROW_DOWN_ANGLE)} />
                                        </div>
                                    </div>

                                    {
                                        this.state.showCaseStudyList == true ?

                                            <>
                                                <div className='divider mt-1 mb-1'></div>
                                                <div className="p-4">
                                                    {
                                                        this.state.caseStudyInfo.length ? this.state.caseStudyInfo.map((caseStudy, index) => (
                                                            <div id={caseStudy._id} className={`case-study-item d-flex justify-content-between ${index === 0 ? '' : 'mt-3'}`}
                                                                onMouseEnter={ReactTooltip.rebuild}
                                                            >
                                                                <div className="d-flex align-items-center cursor-pointer" onClick={() => this.showCaseStudyDetail(caseStudy)}>
                                                                    <div className="mr-1 case-study-title ">{index + 1}.</div>
                                                                    <CwContentViewer from='case_study' content={caseStudy.caseStudyTitle} />
                                                                    {/* <img className="download-icon" src={getImageSource(ImageConstants.CASE_STUDY_DOWNLOAD_ICON)} data-tip={"Download Case Study"} /> */}
                                                                </div>
                                                                <div className="" >
                                                                    <span className="view-more-text cursor-pointer" onClick={() => this.showCaseStudyDetail(caseStudy)}>{'View More'}</span>
                                                                    <img className="view-more-icon ml-2 cursor-pointer" src={getImageSource(ImageConstants.VIEW_MORE_IMAGE)} onClick={() => this.showCaseStudyDetail(caseStudy)} />
                                                                    {/* <span className="ml-3 cursor-pointer">Have You Learned ?
                                                                        {
                                                                            this.state.rewardAssigned[`${this.state.chapterKey}_${caseStudy._id}`] ?
                                                                                <img className="react-image ml-2" src={getImageSource(ImageConstants.RECT_TICK)} />
                                                                                :
                                                                                <img className="react-image ml-2" src={getImageSource(ImageConstants.RECT_BLACK)} 
                                                                                onClick={() => this.videoEnded(this.state.chapterKey, caseStudy.caseStudyTitle, caseStudy, "CASE_STUDY", "CASE_STUDY_ASSIGN")}/>
                                                                        }
                                                                    </span> */}
                                                                </div>




                                                            </div>
                                                        ))

                                                            :
                                                            <div className="text-center">No Case Study</div>
                                                    }
                                                </div>
                                            </>
                                            : <></>
                                    }


                                </div>
                            }
                        </>
                        :
                        <></>
                }

                {
                    this.state.chapterActivityInfo.length && !classesExcludeList.includes(this.state.selectedClass) ?
                        <>
                            {

                                <div className="chapter-activity-card mt-4">
                                    <img className="case-study-bg" src={getImageSource(ImageConstants.ACTIVITY_BG)} />
                                    <div className="d-flex justify-content-between align-items-center cursor-pointer p-3" onClick={() => this.toggleMenu('chapter_activity_expand')}>
                                        <div className="d-flex align-items-center">
                                            <div className="mr-2">
                                                <img className="book-with-apple" src={getImageSource(ImageConstants.CHAPTER_ACTIVITY_ICON)} />
                                            </div>
                                            <div className="heading">Activities <span className="count-text">{` (${this.state.chapterActivityInfo.length})`}</span> </div>
                                        </div>
                                        <div>
                                            <img className="arrow-size-for-case-study" src={getImageSource(this.state.showChapterActivityList ? ImageConstants.ARROW_UP_ANGLE : ImageConstants.ARROW_DOWN_ANGLE)} />
                                        </div>
                                    </div>
                                    {
                                        this.state.showChapterActivityList ?

                                            <>
                                                <div className='divider mt-1 mb-1'></div>
                                                <div className="p-4">
                                                    {
                                                        this.state.chapterActivityInfo.length ? this.state.chapterActivityInfo.map((activity, index) => (
                                                            <div id={activity._id} className={`case-study-item d-flex justify-content-between cursor-pointer  ${index === 0 ? '' : 'mt-3'}`}

                                                                onMouseEnter={ReactTooltip.rebuild}>
                                                                <div className="chapter-activity-download d-flex align-items-center cursor-pointer" onClick={() => { this.showActivityDetail(activity) }}>
                                                                    <span className="mr-1 case-study-title ">{index + 1}.</span>
                                                                    <CwContentViewer from='case_study' content={activity.activityTitle} />
                                                                    {/* <img className="download-icon" src={getImageSource(ImageConstants.CASE_STUDY_DOWNLOAD_ICON)} data-tip={'Download Activity'} /> */}
                                                                </div>
                                                                <div className="" >
                                                                    <span className="view-more-text cursor-pointer" onClick={() => { this.showActivityDetail(activity) }}>{'View More'}</span>
                                                                    <img className="view-more-icon ml-2 cursor-pointer" src={getImageSource(ImageConstants.VIEW_MORE_IMAGE)} onClick={() => { this.showActivityDetail(activity) }} />
                                                                    {/* <span className="ml-3 cursor-pointer">Have You Learned ?
                                                                        {
                                                                            this.state.rewardAssigned[`${this.state.chapterKey}_${activity._id}`] ?
                                                                                <img className="react-image ml-2" src={getImageSource(ImageConstants.RECT_TICK)} />
                                                                                :
                                                                                <img className="react-image ml-2" src={getImageSource(ImageConstants.RECT_BLACK)} 
                                                                                onClick={() => this.videoEnded(this.state.chapterKey, activity.activityTitle, activity, "CHAPTER_ACTIVITY", "CHAPTER_ACTIVITY_ASSIGN")}/>
                                                                        }
                                                                    </span> */}
                                                                </div>

                                                                {/* <span className="sub-heading mt-4">
                                    <CwContentViewer from='case_study' content={activity.activityTitle} />
                                </span> */}
                                                                {
                                                                    this.state.activityList[index] &&
                                                                    this.state.selectedActivityIndex === index &&
                                                                    activity.questions.map((item) => (
                                                                        <>
                                                                            <span className="sub-heading mt-2">Learning Objective</span>
                                                                            <CwContentViewer content={item.title} />
                                                                            {
                                                                                item.images.length ?
                                                                                    item.images.map(image => (
                                                                                        <img className="case-study-image" src={image.imageUrl} />
                                                                                    ))

                                                                                    : <></>
                                                                            }
                                                                            <div className="sub-heading mt-2">Materials required</div>
                                                                            <CwContentViewer content={item.answer} />
                                                                            <div className="sub-heading mt-2">{`Procedure`}</div>
                                                                            <CwContentViewer content={item.solution} />
                                                                        </>
                                                                    ))
                                                                }
                                                            </div>
                                                        ))

                                                            :
                                                            <div className="text-center">No Activity</div>
                                                    }
                                                </div>
                                            </>

                                            :
                                            <></>
                                    }

                                </div>
                            }
                        </>
                        :
                        <></>
                }







                {this.state.showAssignHomeworkPopup ? this.assignHomeworkModal() : ''}
                {this.state.showHomeworkListModal ? this.viewHomeworkListModal() : ''}

                {this.state.showAssignClassworkPopup ? this.assignClassworkModal() : ''}
                {this.state.showClassworkListModal ? this.viewClassworkListModal() : ''}

                {this.state.showAssignVideoModal ? this.assignVideoModal() : ''}

                {this.state.showToaster ? <div className='custom-toaster-modal'> <ToasterComponent image={this.state.toasterImage} message={this.state.toasterMessage} type={this.state.toasterType} position="bottom-center" /></div> : ""}
                {this.state.showLearningOutcomeVideoModal ? this.watchLearningOutcomeVideo() : ''}
                <ReactTooltip ref={el => this.tooltip = el} multiline={true} place='bottom' type='dark' effect='solid' event="mouseover mouseenter" eventOff="mouseleave mouseout scroll mousewheel blur" />
            </div>
        )






    }
}

export default ChapterDetails